import { useCreate, useDelete, useDetail, useList, useUpdate, usePartialUpdate, useAction } from "@inmagik/react-crud"
import type { NamedEntity } from "../types"
import { API_URL } from "../constants"
import { useAuth } from "../auth"
import { useCallback } from "react"
import { fetchApi, normalizeParams } from "@inmagik/react-crud/dist/crud/utils"

export function useNamedEntitiesList(params: Record<string, string> = {}) {
  return useList<NamedEntity>(`${API_URL}/admin/named-entities`, {
    query: params,
  })
}

export function useNamedEntity(id: number | undefined) {
  return useDetail<NamedEntity>(`${API_URL}/admin/named-entities`, id?.toString())
}

export function useCreateNamedEntity() {
  return useCreate<NamedEntity>(`${API_URL}/admin/named-entities`)
}

export function useUpdateNamedEntity() {
  return useUpdate<NamedEntity>(`${API_URL}/admin/named-entities`)
}

export function useDeleteNamedEntity() {
  return useDelete(`${API_URL}/admin/named-entities`)
}

export function usePartialUpdateNamedEntity() {
  return usePartialUpdate<NamedEntity>(`${API_URL}/admin/named-entities`)
}

export function useDeleteMultiNamedEntity() {
  return useAction(`${API_URL}/admin/named-entities/delete_multi/`, {
    method: "POST",
    responseType: "text",
  })
}

export function useNamedEntityLazy() {
  const auth = useAuth()
  return useCallback((id: number) => {
    return fetchApi(`${API_URL}/admin/named-entities/${id}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<NamedEntity>
  }, [])
}

export function useNamedEntitiesLazy(params: Record<string, string | number | Array<number>> = {}) {
  const auth = useAuth()
  return useCallback((paramsOverride: Record<string, string | number | Array<number>> = {}) => {
    const combinedParams = { ...params, ...paramsOverride }
    const qs = normalizeParams(combinedParams).toString()
    return fetchApi(`${API_URL}/admin/named-entities?${qs}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<{ results: NamedEntity[] }>
  }, [])
}
